import { BaseService } from './base-service';
import {
	CreateEmployerRequestDTO,
	CreateEmployerResponseDTO,
	DestroyEmployerRequestDTO,
	DestroyEmployerResponseDTO,
	GetEmployerRequestDTO,
	GetEmployerResponseDTO,
	GetListEmployerRequestDTO,
	GetListEmployerResponseDTO,
	UpdateEmployerRequestDTO,
	UpdateEmployerResponseDTO
} from '@/core/dto/employer';

export class EmployerService extends BaseService<any> {
	private static instance: EmployerService;

	private constructor(public readonly basePath: string = '/employer') {
		super();
	}

	public static getInstance(): EmployerService {
		if (!EmployerService.instance) {
			EmployerService.instance = new EmployerService();
		}
		return EmployerService.instance;
	}

	public async show(params: GetEmployerRequestDTO): Promise<GetEmployerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetEmployerResponseDTO>(url, { params });
		return data;
	}

	public async index(params: GetListEmployerRequestDTO): Promise<GetListEmployerResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().get<GetListEmployerResponseDTO>(url, { params });
		return data;
	}

	public async create(params: CreateEmployerRequestDTO): Promise<CreateEmployerResponseDTO> {
		const url = this.basePath + '/';
		const { data } = await this.getInstance().post<CreateEmployerResponseDTO>(url, params);
		return data;
	}

	public async update(params: UpdateEmployerRequestDTO): Promise<UpdateEmployerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().put<UpdateEmployerResponseDTO>(url, params);
		return data;
	}

	public async destroy(params: DestroyEmployerRequestDTO): Promise<DestroyEmployerResponseDTO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().delete<DestroyEmployerResponseDTO>(url, { params });
		return data;
	}
}
